import { render } from "./pepoleView.vue?vue&type=template&id=15ffaea8"
import script from "./pepoleView.vue?vue&type=script&lang=js"
export * from "./pepoleView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__